"use client"
import { Navbar, Nav, Container, Button } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import { useAuth } from "../contexts/AuthContext"

const Header = () => {
  const { user, logout } = useAuth()

  return (
    <Navbar bg="success" variant="dark" expand="lg" className="shadow-sm">
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand className="fw-bold">🌱 AgroPlanner</Navbar.Brand>
        </LinkContainer>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/">
              <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/crop-rotation">
              <Nav.Link>🔄 Crop Rotation</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/weather">
              <Nav.Link>🌤️ Weather Info</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/about">
              <Nav.Link>About</Nav.Link>
            </LinkContainer>
          </Nav>

          <Nav>
            {user ? (
              <>
                <LinkContainer to="/admin">
                  <Nav.Link>Admin Panel</Nav.Link>
                </LinkContainer>
                <Button variant="outline-light" size="sm" onClick={logout} className="ms-2">
                  Logout
                </Button>
              </>
            ) : (
              <LinkContainer to="/admin/login">
                <Nav.Link>Admin Login</Nav.Link>
              </LinkContainer>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Header
